<ng-container *ngIf="authorization; else noAuth">
<app-toolbar [back]="back" [destination]="destination" [title]="title" [user]="user"></app-toolbar>

<div class="form" style="padding-bottom: 70px">
  <div style="text-align: center; padding-bottom: 20px; padding-top: 20px">
    <h3>Compila il questionario!</h3>
    <h4>Per ogni domanda selezionare SOLO una risposta</h4>
  </div>

  <form [formGroup]="qForm" (ngSubmit)="onSubmit()">

    <div style="font-weight: bold"
         fxLayout="row wrap"
         fxLayout.lt-sm="column"
         fxLayoutGap="20px"
         fxLayoutAlign="center">

    </div>

    <mat-card class="mat-elevation-z4" style="margin: auto; max-width: 1270px">
    <div class="container">

      <div *ngFor="let question of source">
        <label id="example-radio-group-label"><h4>{{question.position}}. {{question.question}}</h4></label>
      <mat-radio-group
        aria-labelledby="example-radio-group-label"
        class="example-radio-group">
        <mat-radio-button [disableRipple]="true" #button (click)="checkState(button, question.position)"
          class="example-radio-button" (change)="setAnswer(answer, question.position)"
                          *ngFor="let answer of question.answers" [value]="answer">
          {{answer}}
        </mat-radio-button>
      </mat-radio-group>
      </div>
    </div>

    <div style="margin-top: 40px; padding-bottom: 60px" fxLayout="row wrap">
      <ul>
        <li>Vorremmo sapere quanto è buona o cattiva la sua salute OGGI.</li>
        <li>Questa è una scala numerata che va da 0 a 100.</li>
        <li>100 rappresenta la <strong>migliore</strong> salute che può immaginare.<br>
        0 rappresenta la <strong>peggiore</strong> salute che può immaginare.</li>
        <li>Selezioni dalla scala un valore da 0 a 100 per indicare com'è la sua salute OGGI.</li>
      </ul>
        <mat-slider
          class="slider"
          [max]="100"
          [min]="0"
          [step]="1"
          [vertical]="true"
          [thumbLabel]="true"
          [(value)]="sliderValue"
          (change)="setHealth()">
        </mat-slider>
    </div>
    </mat-card>
    <div style="text-align: center; padding-top: 50px; padding-bottom: 50px;
           justify-content: center; align-content: center; align-items: center;">
      <ng-container *ngIf="submitted">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-container>

      <ng-container *ngIf="!show">
        <button  class="mat-elevation-z4" mat-raised-button type="submit" color="primary">Invia</button>
      </ng-container>
    </div>

  </form>

</div>
</ng-container>
<ng-template #noAuth>
  <app-toolbar [back]="back" [destination]="destination" [title]="'Accesso non autorizzato'" [user]="user"></app-toolbar>
  <div style="padding-bottom: 20px; padding-top: 20px; text-align: center;">
    <h4>
      L'accesso a questa pagina non è autorizzato. Torna alla home
    </h4>
    <button mat-raised-button color="warn" (click)="goHome()">Home</button>
  </div>
</ng-template>
